import { HomeScreen } from "../../features/home";

/** FS-01-02 놀이터 입구 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/home */
export default function HomePage() {
  return <HomeScreen />;
}
